import React from 'react';

function ServerErrors(props) {
    if (!props) {
        return null;
    }

    const { errors } = props;

    return (
        <section className="server-errors">
            <ul>
                {errors.map((serverError) => (
                    <li>{serverError}</li>
                ))}
            </ul>
        </section>
    );
}

export { ServerErrors };
